import React from 'react';
import { Edit, TopToolbar, ListButton, DeleteButton } from 'react-admin';
import { CustomerForm } from './CustomerForm';
import useAdmin from '../hooks/useAdmin';
import { stripUnmanagedGsts } from '../utils/gstFormTransform';

const CustomerEditActions = () => (
    <TopToolbar>
        <ListButton />
        <DeleteButton />
    </TopToolbar>
);

export const CustomerEdit = (props: any) => {
    useAdmin();
    return (
        <Edit title="Edit Customer" actions={<CustomerEditActions />} transform={stripUnmanagedGsts} {...props}>
            <CustomerForm isEdit={true} />
        </Edit>
    );
};

export default CustomerEdit;
